import { Tabs } from 'antd'
import PerFlexRow from '../../../components/custom_components/FlexRow'
import PerText from '../../../components/custom_components/Text'
import { useDashboardStore } from '../DashboardStore'
import { FiltersTabs } from '../dasboardStoreTypes'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import DashboardDistributionsOfficeTabContent from './DashboardDistributionsOfficeTabContent'
import DashboardDistributionsBUMTabContent from './DashboardDistributionsBUMTabContent'
import DashboardDistributionsBUTabContent from './DashboardDistributionsBUTabContent'

const { TabPane } = Tabs

const DashboardFiltersDistributionHeader: FC<{
  activeTab: FiltersTabs
  onTabChange: (tab: FiltersTabs) => void
}> = ({ activeTab, onTabChange }) => {
  const [t] = useTranslation()
  const distributionBubobumCounters = useDashboardStore((state) => state.distributionBubobumCounters)
  const showOfficeTab = (distributionBubobumCounters?.branchOffice ?? 0) > 0

  const DistributionTab: FC<{ label: string; counter?: number }> = ({ label, counter }) => {
    return (
      <PerFlexRow align="middle">
        <PerText mr="xxxs" fontSize="s" color="secondary">
          {label}
        </PerText>
        {counter !== undefined && (
          <div className="dashboard-filters-area__distributions__tab-counter">
            <PerText fontWeight="bold" fontSize="xs" color="secondary">
              {counter}
            </PerText>
          </div>
        )}
      </PerFlexRow>
    )
  }

  return (
    <PerFlexRow justify="center" align="middle" className="dashboard-filters-area__distributions__header">
      <Tabs
        className="dashboard-filters-area__distributions__tabs"
        activeKey={activeTab}
        onChange={(key) => onTabChange(key as FiltersTabs)}
        tabBarGutter={0}
        aria-label={t('dashboard.companyManager.filtersArea.distributions.header.tabListAria')}
      >
        <TabPane
          key={FiltersTabs.BUSINESS_UNIT}
          tab={
            <DistributionTab
              label={t('dashboard.companyManager.filtersArea.distributions.businessUnit')}
              counter={distributionBubobumCounters?.businessUnit}
            />
          }
        />
        <TabPane
          key={FiltersTabs.BUMANAGERS}
          tab={
            <DistributionTab
              label={t('dashboard.companyManager.filtersArea.distributions.buManagers')}
              counter={distributionBubobumCounters?.buManagers}
            />
          }
        />
        {showOfficeTab && (
          <TabPane
            key={FiltersTabs.OFFICE}
            tab={
              <DistributionTab
                label={t('dashboard.companyManager.filtersArea.distributions.office')}
                counter={distributionBubobumCounters?.branchOffice}
              />
            }
          />
        )}
      </Tabs>
    </PerFlexRow>
  )
}

const DashboardDistributions: FC = () => {
  const [selectedCompanyId, activeFiltersTab, distributionBubobumCounters, setActiveFiltersTab] = useDashboardStore((state) => [
    state.selected.value,
    state.activeFiltersTab,
    state.distributionBubobumCounters,
    state.setActiveFiltersTab,
  ])

  const showOfficeTab = (distributionBubobumCounters?.branchOffice ?? 0) > 0

  return (
    <div className="dashboard-filters-area__distributions">
      <DashboardFiltersDistributionHeader activeTab={activeFiltersTab} onTabChange={setActiveFiltersTab} />

      <div className="dashboard-filters-area__distributions__body">
        {activeFiltersTab === FiltersTabs.BUSINESS_UNIT && <DashboardDistributionsBUTabContent selectedCompanyId={selectedCompanyId} />}
        {activeFiltersTab === FiltersTabs.BUMANAGERS && <DashboardDistributionsBUMTabContent selectedCompanyId={selectedCompanyId} />}
        {showOfficeTab && activeFiltersTab === FiltersTabs.OFFICE && (
          <DashboardDistributionsOfficeTabContent selectedCompanyId={selectedCompanyId} />
        )}
      </div>
    </div>
  )
}

export default DashboardDistributions
